import {
  createSelector,
  createFeatureSelector,
} from '@ngrx/store';
import * as fromDetection from './detection.reducer';
import { DetectionTools } from '../../tools/detection.tools';


// get the selectors
const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = fromDetection.adapter.getSelectors();

export const selectDetectionState = createFeatureSelector<fromDetection.State>('detections');

export const selectDetectionIds = createSelector(
  selectDetectionState,
  selectIds
);
export const selectDetectionEntities = createSelector(
  selectDetectionState,
  selectEntities
);
export const selectAllDetections = createSelector(
  selectDetectionState,
  selectAll
);
export const selectDetectionTotal = createSelector(
  selectDetectionState,
  selectTotal
);

export const selectCurrentDetectionId = createSelector(
  selectDetectionState,
  fromDetection.getSelectedDetectionId
);

export const selectCurrentDetection = createSelector(
  selectDetectionEntities,
  selectCurrentDetectionId,
  (entities, id) => (id) ? entities[id] : null
);

export const selectDetectionEmergencyTemplate = createSelector(
  selectDetectionState,
  fromDetection.getDetectionEmergencyTemplate
);

export const selectSiteDetectionLabels = createSelector(
  selectDetectionState,
  fromDetection.getSiteDetectionLabels
);

export const selectDetectionSummary = createSelector(
  selectDetectionState,
  fromDetection.getDetectionSummary
);

export const selectDetectionById = (id: string) => createSelector(
  selectDetectionEntities,
  (entities) => {
    return entities[id];
  }
);

export const selectDetectionShowById = (id: string) =>
  createSelector(
    selectDetectionEntities,
    (entities): boolean => !!entities[id]?.show
  );

export const selectDetectionByPool = (pool: string) =>
  createSelector(
    selectDetectionEntities,
    entities => Object.values(entities).find(detection => detection?.pool === pool) ?? null
  );

export const selectDetectionFilters = createSelector(
  selectDetectionState,
  (state) => state.filters
);

export const selectFilteredDetections = createSelector(
  selectAllDetections,
  selectDetectionFilters,
  (detections, filters) => DetectionTools.applyFilters(detections, filters)
);

export const selectFilteredDetectionsTotal = createSelector(
  selectFilteredDetections,
  (detections) => detections.length
);






